/** Browser timezone helpers — API stores UTC ISO strings. */

export function getBrowserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function utcDateKey(iso: string, timeZone?: string): string {
  const tz = timeZone || getBrowserTimezone();
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date(iso));
  const y = parts.find((p) => p.type === 'year')?.value ?? '';
  const m = parts.find((p) => p.type === 'month')?.value ?? '';
  const d = parts.find((p) => p.type === 'day')?.value ?? '';
  return `${y}-${m}-${d}`;
}

export function formatInTimezone(
  iso: string,
  options: Intl.DateTimeFormatOptions,
  timeZone?: string
): string {
  return new Intl.DateTimeFormat('en-US', {
    ...options,
    timeZone: timeZone || getBrowserTimezone(),
  }).format(new Date(iso));
}

export function formatTimeRange(
  startIso: string,
  endIso: string,
  timeZone?: string
): string {
  const tz = timeZone || getBrowserTimezone();
  const start = formatInTimezone(startIso, { hour: 'numeric', minute: '2-digit', hour12: true }, tz);
  const end = formatInTimezone(endIso, { hour: 'numeric', minute: '2-digit', hour12: true }, tz);
  return `${start} – ${end}`;
}

export function formatMoney(cents: number, currency = 'EUR'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(cents / 100);
}

export function getMonthGrid(year: number, month: number): (Date | null)[][] {
  const first = new Date(year, month, 1);
  const startPad = first.getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const cells: (Date | null)[] = [];
  for (let i = 0; i < startPad; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(year, month, d));
  while (cells.length % 7 !== 0) cells.push(null);
  const weeks: (Date | null)[][] = [];
  for (let i = 0; i < cells.length; i += 7) {
    weeks.push(cells.slice(i, i + 7));
  }
  return weeks;
}
